<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal modal-account-verification" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content" style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal">
                <span class="distribute-title">
                  Distribute Campaign
                </span>
                            </p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg" alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content" style="overflow: visible">
                                <div class="text-left">
                                    <h6 class="mt-2 mb-2" style="font-weight: 700">Your file is not formatted as we expected it.</h6>
                                    <p>We could not process your file. Please use our template and try again.</p>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-5">
                                    <button v-text="'Close'"
                                            class="btn-dialog btn-sm ok-btn mr-2 distribution-upload-btn" @click="closeModal">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "ModalCampaignDistributionErrored",
    methods: {
        closeModal() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}
.distribute-title {
    color: #2178AB;
}
.distribute-section {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;

    .section-number {
        background: #7BBDEF;
        color: #FFFFFF;
        width: 44px !important;
        height: 40px;
        margin-right: 20px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 28px;
        font-weight: 700;
    }

    .section-content {
        display: flex;
        flex-direction: column;
        text-align: left;
        color: #555E67;
        font-size: 18px;
        width: 100%;

        ol {
            margin: 0;
            padding-left: 20px;
            font-size: 16px;
        }

    }
}
.distribute-btn {
    font-family: 'Open Sans';
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 280px;
    color: #555E67;
    line-height: 150%;
    margin-top: 10px;
    float: none;
}
.distribution-upload-btn {
    width: 160px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 60px !important;
    border-radius: 20px;
    font-size: 20px !important;
}
</style>
